import { defineAsyncComponent } from "vue";

export default [
  {
    name: "AssignmentViewCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AssignmentViewEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AssignmentViewSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "module/:moduleUuid/section/:sectionId",
    props: true,
  },
  {
    name: "AssignmentViewSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "module/:moduleUuid/section/:sectionId/end",
    props: true,
  },
  {
    name: "AssignmentViewActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "AssignmentViewCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "AssignmentViewDiscussionDatAnalyse",
    component: defineAsyncComponent(
      () =>
        import("@modules/attempt/components/discussion-dat/components/DiscussionDatAnalyse.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId/analyse-data",
    props: true,
  },
  {
    name: "AssignmentViewDiscussionDatAnalyseResult",
    component: defineAsyncComponent(
      () =>
        import("@modules/attempt/components/discussion-dat/components/DiscussionDatAnalyseResult.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId/analyse-data/analysis",
    props: true,
  },
  {
    name: "AssignmentViewDiscussionDatInsight",
    component: defineAsyncComponent(
      () =>
        import("@modules/attempt/components/discussion-dat/components/DiscussionDatInsight.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId/analyse-data/analysis/details",
    props: true,
  },
  {
    name: "DataAssistant",
    component: defineAsyncComponent(
      () => import("@modules/data-assistant/components/DataAssistantContainer.vue"),
    ),
    path: "section/:sectionId/activity/:pageId/data-assistant",
  },
  {
    name: "DataAssistantAdaptive",
    component: defineAsyncComponent(
      () => import("@modules/data-assistant/components/DataAssistantContainer.vue"),
    ),
    path: "section/:sectionId/data-assistant",
  },
  {
    name: "AssignmentViewConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    path: "module-plan",
    name: "AssignmentViewModulePlan",
    component: defineAsyncComponent(
      () => import("@modules/teacher-view-module-plan/CoursePlanAttempt.vue"),
    ),
    props: true,
  },
  {
    path: "not-found",
    name: "AssignmentViewNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
